/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { src__app__ai__rag__router__LuChatPromptPayload } from '../models/src__app__ai__rag__router__LuChatPromptPayload';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class RagService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Chat
     * RAG chat endpoint with streaming via WebSocket
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public chat(
        requestBody: src__app__ai__rag__router__LuChatPromptPayload,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/ai/rag/chat',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
